type EventListener = (...args: any[]) => void | Promise<void>;

class AsyncEventDispatcher {
  private static instance: AsyncEventDispatcher;
  private events: { [event: string]: EventListener[] } = {};
  private dispatchedEvents: { [event: string]: any[] } = {};

  private constructor() {}

  public static getInstance(): AsyncEventDispatcher {
    if (!AsyncEventDispatcher.instance) {
      AsyncEventDispatcher.instance = new AsyncEventDispatcher();
    }
    return AsyncEventDispatcher.instance;
  }

  // Add an event listener
  addEventListener(event: string, listener: EventListener): void {
    if (!this.events[event]) {
      this.events[event] = [];
    }
    this.events[event].push(listener);

    // Replay event if it was already dispatched
    if (this.dispatchedEvents[event]) {
      this.dispatchedEvents[event].forEach((args) => listener(...args));
    }
  }

  // Remove an event listener
  removeEventListener(event: string, listener: EventListener): void {
    if (this.events[event]) {
      this.events[event] = this.events[event].filter(
        (currentListener) => currentListener !== listener
      );
    }
  }

  // Dispatch an event
  async dispatchEvent(event: string, ...args: any[]): Promise<void> {
    if (!this.dispatchedEvents[event]) {
      this.dispatchedEvents[event] = [];
    }

    this.dispatchedEvents[event].push(args);

    if (this.events[event]) {
      const listeners = [...this.events[event]]; // Copy listeners to avoid mutation during execution
      for (const listener of listeners) {
        await listener(...args); // Wait for each listener if it returns a Promise
      }
    }
  }
}

export default AsyncEventDispatcher;
